import React, { useState, useEffect, useMemo } from "react";
import DetailSale from "./DetailSale";
import PaidRevenueModal from "./PaidRevenueModal";
import {
  fetchSales,
  getSaleById,
  cancelSale,
  processSale,
  settleSale,
  fetchSaleBills,
  fetchEligibleSaleBills,
  splitSaleBill,
  mergeSaleBills,
  paySaleBill,
  undoSaleBill,
} from "../../actions/saleAction";
import { connect } from "react-redux";
import { AlertConfirmModal } from "../../components/Modals/AlertConfirmModal";
import PaymentSettlementModal from "../../components/Modals/PaymentSettlementModal";
import AkasSelect from "../../components/AkasSelect";
import DraftPaymentModal from "../../components/Modals/DraftPaymentModal";
import { sortHelper } from "../../utils/helpers/sortHelper";
import { useSearchParams } from "react-router-dom";
import debounce from "lodash/debounce";

import { formatIDR } from "../../utils/helpers/formatIDR";
import { format } from "date-fns";
import { BASE_URL_STORAGE } from "../../helpers/config";
import { useNavigate } from "react-router-dom";
import PATH_URL from "../../routers/path";
import { canEditSale, canProcessSale } from "../../utils/helpers/permissions";
import { toast } from "react-hot-toast";
import BillManagementModal from "./BillManagementModal";
import CashierSummaryModal from "./CashierSummaryModal";

const saleStatus = {
  draft: { label: "Draft", className: "bg-warning-lt" },
  paid: { label: "Lunas", className: "bg-success-lt" },
  unpaid: { label: "Belum Lunas", className: "bg-danger-lt" },
  cancelled: { label: "Dibatalkan", className: "bg-danger-lt" },
};

const getSaleStatus = (status) => saleStatus[status] || { label: status || "-", className: "bg-secondary-lt" };
const today = format(new Date(), "yyyy-MM-dd");

const SummaryCard = ({ title, value, subtitle, color = "primary", icon, modalTarget }) => {
  const Card = modalTarget ? "button" : "div";
  return (
    <div className="col-4 akas-summary-column--three-up">
      <Card
        className={`card h-100 akas-summary-card akas-summary-card--three-up${modalTarget ? " sale-summary-trigger" : ""}`}
        type={modalTarget ? "button" : undefined}
        data-bs-toggle={modalTarget ? "modal" : undefined}
        data-bs-target={modalTarget}
        aria-haspopup={modalTarget ? "dialog" : undefined}
        aria-label={modalTarget ? `Lihat rincian ${title}` : undefined}>
        <div className="card-body ">
          <div className="d-flex align-items-center gap-3">
            <span className={`avatar bg-${color}-lt text-${color} rounded-3 d-none d-lg-block`}>{icon}</span>
            <div className="akas-summary-card-content w-100">
              <div className="text-secondary small fw-bold text-uppercase sale-summary-trigger-label" title={title}>
                <span className="text-truncate">{title}</span>
                {modalTarget ? (
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                    <path d="m9 5 7 7-7 7" />
                  </svg>
                ) : null}
              </div>
              <div className="h1 mb-0 fw-bold d-none d-lg-block" title={String(value)}>
                {value}
              </div>
              <div className="h4 mb-0 fw-bold d-block d-lg-none text-truncate" title={String(value)}>
                {value}
              </div>
              {subtitle ? <div className="text-secondary small mt-1 d-none d-lg-block">{subtitle}</div> : null}
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};

export const SalePage = (props) => {
  const {
    dataSales,
    sales,
    isLoading,
    fetchSales,
    getSaleById,
    processSale,
    cancelSale,
    settleSale,
    fetchSaleBills,
    fetchEligibleSaleBills,
    splitSaleBill,
    mergeSaleBills,
    paySaleBill,
    undoSaleBill,
    userProfile,
    storeSetting,
  } = props;

  const navigate = useNavigate();
  const [perPage, setPerPage] = useState(100);
  const [currentPage, setCurrentPage] = useState(1);

  const handlePerPageChange = (value) => {
    setPerPage(value);
    setCurrentPage(1);
  };

  const initialState = {
    id: "",
    name: "",
    email: "",
    phone: "",
    address: "",
    shopname: "",
    image: "",
    image_url: "",
    image_path: "",
    category: "",
    account_holder: "",
    account_number: "",
    bank_name: "",
    city_id: "",
  };
  const [formState, setFormState] = useState(initialState);
  const [selectedSaleDetail, setSelectedSaleDetail] = useState(null);
  const [isDetailLoading, setIsDetailLoading] = useState(false);

  const [statusFilter, setStatusFilter] = useState("");
  const [dateRange, setDateRange] = useState({ startDate: today, endDate: today });
  const [searchParams, setSearchParams] = useSearchParams();
  const searchFromUrl = searchParams.get("search") || "";

  const [filterText, setFilterText] = useState(searchFromUrl);

  const { sortConfig, handleSort, getSortedData } = sortHelper.useSort();
  const closeModal = () => {
    setFormState(initialState);
  };
  const fetchFilter = useMemo(
    () => ({
      start_date: dateRange.startDate,
      end_date: dateRange.endDate,
    }),
    [dateRange.endDate, dateRange.startDate],
  );
  const refreshData = () => fetchSales(perPage, currentPage, searchFromUrl, statusFilter, fetchFilter);
  const handleProcess = async (id, payload) => {
    if (!canProcessSale(userProfile, formState)) return false;
    const success = await processSale(id, payload, { refreshSales: false });
    if (success) {
      refreshData();
    }
    return success;
  };
  const handleCancel = async (id, reason) => {
    const success = await cancelSale(id, reason, { refreshSales: false });
    if (success) {
      await refreshData();
    }
    return success;
  };
  const handleSettle = async (id, payload) => {
    if (!canProcessSale(userProfile, formState)) return false;
    const success = await settleSale(id, payload, { refreshSales: false });
    if (success) {
      refreshData();
    }
    return success;
  };
  const handleOpenDetail = async (sale) => {
    setSelectedSaleDetail({ ...sale });
    setIsDetailLoading(true);

    const result = await getSaleById(sale?.id, { silent: true });
    if (result?.success) {
      setSelectedSaleDetail(result.data);
    } else {
      toast.error("Detail penjualan belum dapat dimuat. Silakan coba lagi.");
    }

    setIsDetailLoading(false);
  };
  const handlePrintInvoice = (saleId) => {
    if (!saleId) return;
    navigate(PATH_URL.TESTING_PRINT_INVOICE.replace(":id", saleId));
  };
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setFilterText(value);

    if (value) {
      setSearchParams({ search: value });
    } else {
      setSearchParams({});
    }
  };

  useEffect(() => {
    setFilterText(searchFromUrl);
  }, [searchFromUrl]);

  const debouncedFetch = useMemo(
    () =>
      debounce((page, limit, search) => {
        fetchSales(limit, page, search, statusFilter, fetchFilter);
      }, 500),
    [fetchSales, statusFilter, fetchFilter],
  );
  useEffect(() => {
    debouncedFetch(currentPage, perPage, searchFromUrl);

    return () => {
      debouncedFetch.cancel();
    };
  }, [currentPage, perPage, searchFromUrl, statusFilter, dateRange.startDate, dateRange.endDate, debouncedFetch]);
  useEffect(() => {
    setCurrentPage(1);
  }, [searchFromUrl, statusFilter, dateRange.startDate, dateRange.endDate]);

  const saleSummary = useMemo(() => {
    const summary = dataSales?.summary || {};
    const activeSales = sales.filter((sale) => !["cancel", "cancelled"].includes(sale?.payment_status));
    const productQty = activeSales.reduce(
      (total, sale) =>
        total + (sale?.details || []).reduce((detailTotal, detail) => detailTotal + Number(detail?.qty || 0), 0),
      0,
    );
    const paidRevenue = activeSales
      .filter((sale) => sale?.payment_status === "paid")
      .reduce((total, sale) => total + Number(sale?.total || 0), 0);

    return {
      transactionCount: summary.total_transactions ?? summary.transaction_count ?? activeSales.length,
      productQty: summary.total_products ?? summary.total_qty ?? productQty,
      paidRevenue: summary.paid_revenue ?? summary.paid_total ?? paidRevenue,
    };
  }, [dataSales?.summary, sales]);

  // The modal and card share the same backend aggregate, never just the current page.
  const summaryFilters = dataSales?.summary?.filters;
  const isSummaryCurrent =
    summaryFilters &&
    (summaryFilters.start_date || "") === dateRange.startDate &&
    (summaryFilters.end_date || "") === dateRange.endDate &&
    (summaryFilters.status || "") === statusFilter &&
    (summaryFilters.search || "") === searchFromUrl;

  return (
    <div className="page-wrapper">
      <div className="page-header d-print-none">
        <div className="container-xl">
          <div className="row g-2 align-items-center">
            <div className="col">
              <h1 className="page-title fs-1 text-capitalize">Data Penjualan</h1>
              <div className="page-pretitle">master penjualan</div>
            </div>
            <div className="col-auto ms-auto d-print-none">
              <div className="btn-list">
                {/* <button type="button"
                   
                   className="btn btn-primary btn-5 d-none d-sm-inline-block"
                   data-bs-toggle="modal"
                   data-bs-target="#modal-form"
                   onClick={openModal}>
                   <svg
                     xmlns="http://www.w3.org/2000/svg"
                     width="24"
                     height="24"
                     viewBox="0 0 24 24"
                     fill="none"
                     stroke="currentColor"
                     strokeWidth="2"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                     className="icon icon-2">
                     <path d="M12 5l0 14" />
                     <path d="M5 12l14 0" />
                   </svg>
                   Tambah sale
                  </button>
                  <button type="button"
                   
                   className="btn btn-primary btn-6 d-sm-none btn-icon"
                   data-bs-toggle="modal"
                   data-bs-target="#modal-form"
                   onClick={openModal}>
                   <svg
                     xmlns="http://www.w3.org/2000/svg"
                     width="24"
                     height="24"
                     viewBox="0 0 24 24"
                     fill="none"
                     stroke="currentColor"
                     strokeWidth="2"
                     strokeLinecap="round"
                     strokeLinejoin="round"
                     className="icon icon-2">
                     <path d="M12 5l0 14" />
                     <path d="M5 12l14 0" />
                   </svg>
                  </button> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="page-body">
        <div className="container-xl">
          <div className="row row-deck row-cards">
            <SummaryCard
              title="Transaksi"
              modalTarget="#modal-sale-cashier-summary"
              value={Number(saleSummary.transactionCount || 0).toLocaleString("id-ID")}
              subtitle="Dalam rentang tanggal"
              color="primary"
              icon={
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path d="M5 3h14v18l-3-2l-2 2l-2-2l-2 2l-2-2l-3 2z" />
                  <path d="M9 8h6M9 12h6" />
                </svg>
              }
            />
            <SummaryCard
              title="Produk"
              value={Number(saleSummary.productQty || 0).toLocaleString("id-ID")}
              subtitle="Total qty terjual"
              color="success"
              icon={
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path d="M4 7l8-4l8 4v10l-8 4l-8-4z" />
                  <path d="M4 7l8 4l8-4M12 11v10" />
                </svg>
              }
            />
            <SummaryCard
              title="Omzet Lunas"
              modalTarget="#modal-sale-paid-revenue"
              value={formatIDR(saleSummary.paidRevenue || 0)}
              subtitle="Lihat rincian metode pembayaran"
              color="success"
              icon={
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path d="M3 6h18v12H3z" />
                  <path d="M7 10h.01M17 14h.01" />
                  <circle cx="12" cy="12" r="2" />
                </svg>
              }
            />
            <div className="col-12">
              <div className="card">
                <div className="card-table">
                  <div className="card-header ">
                    <div className="row w-full align-items-center">
                      <div className="col-lg-3 col-12">
                        <h3 className="card-title mb-0">Penjualan</h3>
                        <p className="text-secondary m-0">Master Penjualan</p>
                      </div>
                      <div className="col-lg-2 col-md-4 col-4 my-lg-0 my-2">
                        <AkasSelect
                          className="form-select"
                          value={statusFilter}
                          onChange={(event) => setStatusFilter(event.target.value)}>
                          <option value="">Semua Status</option>
                          <option value="draft">Draft</option>
                          <option value="paid">Lunas</option>
                          <option value="unpaid">Belum Lunas</option>
                          <option value="cancelled">Dibatalkan</option>
                        </AkasSelect>
                      </div>
                      <div className="col-lg-2 col-md-4 col-4 my-lg-0 my-2">
                        <input
                          type="date"
                          className="form-control"
                          value={dateRange.startDate}
                          onChange={(event) => setDateRange((prev) => ({ ...prev, startDate: event.target.value }))}
                        />
                      </div>
                      <div className="col-lg-2 col-md-4 col-4 my-lg-0 my-2">
                        <input
                          type="date"
                          className="form-control"
                          value={dateRange.endDate}
                          onChange={(event) => setDateRange((prev) => ({ ...prev, endDate: event.target.value }))}
                        />
                      </div>
                      <div className="col-lg-3 col-md-12 col-12 my-lg-0 my-2">
                        <div className="input-group input-group-flat w-auto">
                          {isLoading ? (
                            <span className="input-group-text">
                              <div
                                className="spinner-border spinner-border-sm text-primary text-center"
                                role="status"></div>
                            </span>
                          ) : (
                            <span className="input-group-text">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="icon icon-1">
                                <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" />
                                <path d="M21 21l-6 -6" />
                              </svg>
                            </span>
                          )}

                          <input
                            id="advanced-table-search"
                            type="text"
                            className="form-control"
                            autoComplete="off"
                            onChange={handleSearchChange}
                            placeholder="Cari..."
                            value={filterText}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="advanced-table">
                    <div className="table-responsive">
                      <table className="table table-vcenter table-selectable">
                        <thead className="table-header">
                          <tr>
                            <th className="sort-name py-3 w-1">No.</th>
                            <sortHelper.SortableHeader
                              label="Tanggal"
                              sortKey="sale_date"
                              sortConfig={sortConfig}
                              onSort={handleSort}
                            />

                            <sortHelper.SortableHeader
                              label="Kasir"
                              sortKey="cashier_name"
                              sortConfig={sortConfig}
                              onSort={handleSort}
                            />

                            <sortHelper.SortableHeader
                              label="Pelanggan"
                              sortKey="customer_name"
                              sortConfig={sortConfig}
                              onSort={handleSort}
                            />

                            <th className="sort-status fw-bold">Produk</th>
                            <th className="sort-status fw-bold">Diskon</th>
                            <sortHelper.SortableHeader
                              label="Total"
                              sortKey="total"
                              sortConfig={sortConfig}
                              onSort={handleSort}
                            />
                            <th className="sort-status fw-bold">Bayar</th>
                            <th className="sort-status fw-bold">Metode Bayar</th>
                            <th className="sort-status fw-bold">Status</th>
                            <th
                              className="text-start"
                              style={{
                                width: "25%",
                              }}></th>
                          </tr>
                        </thead>

                        <tbody className="table-tbody">
                          {isLoading
                            ? [...Array(sales?.length || 5)]?.map((_, index) => (
                                <tr
                                  key={`loading-${index}`}
                                  style={{
                                    cursor: "loader",
                                  }}>
                                  <td className="sort-name py-4">{(currentPage - 1) * perPage + index + 1}.</td>
                                  {[...Array(9)].map((_, i) => (
                                    <td key={i}>
                                      <div className="placeholder placeholder-lg w-75"></div>
                                    </td>
                                  ))}
                                  <td className="justify-content-start text-start flex-nowrap">
                                    <div
                                      className="placeholder placeholder-lg me-2 "
                                      style={{
                                        width: "40%",
                                      }}></div>
                                    <div
                                      className="placeholder placeholder-lg "
                                      style={{
                                        width: "40%",
                                      }}></div>
                                  </td>
                                </tr>
                              ))
                            : getSortedData(sales)?.map((Sale, index) => (
                                <tr key={Sale.id}>
                                  <td className="sort-name">{(currentPage - 1) * perPage + index + 1}.</td>
                                  <td className="sort-id">
                                    <span className="badge fw-bold">
                                      {" "}
                                      {format(new Date(Sale?.sale_date), "dd MMM yyyy")}
                                    </span>
                                  </td>
                                  <td data-label="Kasir">
                                    <span className="fw-semibold">{Sale.cashier_name || (Sale.created_by ? `Akun #${Sale.created_by}` : "Tidak tercatat")}</span>
                                  </td>
                                  <td data-label="Nama">{Sale.customer_name}</td>
                                  <td className="sort-status fw-bold  text-primary text-start">
                                    {Sale?.details?.map((item, index) => {
                                      const dataImageUrl = item.image ? BASE_URL_STORAGE + item.image : null;

                                      const name = item?.product_name?.trim() || "";
                                      const shortName = name.length > 10 ? name.substring(0, 30) + "..." : name;

                                      return (
                                        <span className="tag text-truncate fs-6 m-1" key={index} title={name}>
                                          <span
                                            className="avatar avatar-xxs tag-avatar fs-6"
                                            style={{
                                              backgroundImage: dataImageUrl ? `url(${dataImageUrl})` : "none",
                                            }}>
                                            {!dataImageUrl && name.charAt(0)}
                                          </span>

                                          {shortName}
                                        </span>
                                      );
                                    })}
                                  </td>
                                  <td className="sort-city">
                                    <span className="badge fw-bold">{formatIDR(Sale?.discount)}</span>
                                  </td>
                                  <td className="sort-id">
                                    <span className="badge fw-bold">{formatIDR(Sale?.total)}</span>
                                  </td>
                                  <td className="sort-city">
                                    <span className="badge fw-bold text-primary">{formatIDR(Sale?.pay)}</span>
                                  </td>

                                  <td className="sort-status fw-bold text-uppercase text-primary text-start">
                                    {Sale?.payment_method}
                                  </td>
                                  <td className="sort-status fw-bold text-uppercase text-start">
                                    <span className={`badge ${getSaleStatus(Sale?.payment_status).className}`}>
                                      {getSaleStatus(Sale?.payment_status).label}
                                    </span>
                                  </td>

                                  <td>
                                    <div className="btn-list flex-nowrap justify-content-start">
                                      <button
                                        type="button"
                                        className="btn btn-1 bg-secondary-lt"
                                        data-bs-toggle="modal"
                                        data-bs-target="#modal-sale-detail"
                                        aria-label={`Lihat detail penjualan ${Sale?.invoice_no || Sale?.id}`}
                                        onClick={() => handleOpenDetail(Sale)}>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="currentColor"
                                          strokeWidth="1.5"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          className="icon icon-tabler icons-tabler-outline icon-tabler-list-details">
                                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                          <path d="M13 5h8M13 9h5M13 15h8M13 19h5" />
                                          <path d="M3 5a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z" />
                                          <path d="M3 15a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z" />
                                        </svg>
                                        Detail
                                      </button>
                                      {Sale?.payment_status !== "cancelled" &&
                                      (Sale?.payment_status !== "paid" || Sale?.has_managed_bills) ? (
                                        <button
                                          type="button"
                                          className="btn btn-1 bg-primary-lt"
                                          data-bs-toggle="modal"
                                          data-bs-target="#modal-sale-bills"
                                          aria-label={`Kelola tagihan ${Sale?.invoice_no || Sale?.id}`}
                                          onClick={() => setFormState({ ...Sale })}>
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="icon">
                                            <path d="M6 3h12v18l-3-2l-3 2l-3-2l-3 2z" />
                                            <path d="M9 8h6M9 12h6M9 16h3" />
                                          </svg>
                                          {Sale?.payment_status === "paid" && Sale?.has_managed_bills
                                            ? "Koreksi Tagihan"
                                            : "Tagihan"}
                                          {Number(Sale?.bill_count || 0) > 1 ? (
                                            <span className="badge bg-primary text-primary-fg ms-1">
                                              {Sale.bill_count}
                                            </span>
                                          ) : null}
                                        </button>
                                      ) : null}
                                      {canEditSale(userProfile, Sale) &&
                                      ["draft", "unpaid"].includes(Sale?.payment_status) &&
                                      !Sale?.has_managed_bills ? (
                                        <button
                                          type="button"
                                          className="btn btn-1 bg-primary-lt"
                                          aria-label={`Ubah transaksi ${Sale?.invoice_no || Sale?.id}`}
                                          onClick={() => navigate(`${PATH_URL.POS}?edit_sale=${Sale.id}`)}>
                                          <svg
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="icon">
                                            <path d="M4 20h4l11-11a2.8 2.8 0 0 0-4-4l-11 11v4" />
                                            <path d="M13.5 6.5l4 4" />
                                          </svg>
                                          Ubah
                                        </button>
                                      ) : null}
                                      {/* {canProcessSale(userProfile, Sale) && Sale?.payment_status === "draft" && !Sale?.has_managed_bills ? (
                                        <button
                                          type="button"
                                          className="btn btn-1 bg-success-lt"
                                          data-bs-toggle="modal"
                                          data-bs-target="#modal-process-draft-sale"
                                          aria-label="Bayar dan proses transaksi draft"
                                          onClick={() => setFormState({ ...Sale })}>
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="icon">
                                            <path d="M5 12l5 5l9 -9" />
                                          </svg>
                                          Bayar &amp; Proses
                                        </button>
                                      ) : null} */}
                                      {/* {Sale?.payment_status !== "cancelled" && Sale?.payment_status !== "paid" ? (
                                        <button
                                          type="button"
                                          className="btn btn-1 bg-secondary-lt"
                                          aria-label="Print invoice"
                                          onClick={() => {
                                            navigate(PATH_URL.TESTING_PRINT_INVOICE.replace(":id", Sale?.id));
                                          }}>
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="icon icon-tabler icons-tabler-outline icon-tabler-printer">
                                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                            <path d="M17 17h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-14a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2" />
                                            <path d="M17 9v-4a2 2 0 0 0 -2 -2h-6a2 2 0 0 0 -2 2v4" />
                                            <path d="M7 15a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2l0 -4" />
                                          </svg>
                                          Print
                                        </button>
                                      ) : null} */}

                                      {/* {canProcessSale(userProfile, Sale) &&
                                      Sale?.payment_status === "unpaid" &&
                                      !Sale?.has_managed_bills ? (
                                        <button
                                          type="button"
                                          className="btn btn-1 bg-primary-lt"
                                          data-bs-toggle="modal"
                                          data-bs-target="#modal-settle-sale"
                                          aria-label="Proses pelunasan"
                                          onClick={() => setFormState({ ...Sale })}>
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="icon">
                                            <path d="M12 3v18" />
                                            <path d="M17 8h-7.5a2.5 2.5 0 0 0 0 5h5a2.5 2.5 0 0 1 0 5h-8.5" />
                                          </svg>
                                          Lunasi
                                        </button>
                                      ) : null} */}

                                      {canEditSale(userProfile, Sale) &&
                                      Sale?.payment_status !== "cancelled" &&
                                      !Sale?.has_managed_bills ? (
                                        <button
                                          type="button"
                                          className="btn btn-1 bg-warning-lt"
                                          data-bs-toggle="modal"
                                          data-bs-target="#modal-cancel-sale"
                                          aria-label="Batalkan transaksi"
                                          onClick={() => setFormState({ ...Sale })}>
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="icon">
                                            <path d="M18 6l-12 12" />
                                            <path d="M6 6l12 12" />
                                          </svg>
                                          Cancel
                                        </button>
                                      ) : null}
                                    </div>
                                  </td>
                                </tr>
                              ))}
                        </tbody>
                      </table>
                    </div>
                    <div className="card-footer d-flex align-items-center">
                      <div className="dropdown">
                        <button className="btn dropdown-toggle" data-bs-toggle="dropdown">
                          <span id="page-count" className="me-1">
                            {perPage}
                          </span>
                          <span>records</span>
                        </button>
                        <div className="dropdown-menu">
                          {[10, 20, 50, 100]?.map((value) => (
                            <button key={value} className="dropdown-item" onClick={() => handlePerPageChange(value)}>
                              {value} records
                            </button>
                          ))}
                        </div>
                      </div>
                      <div className="d-flex ">
                        <p className="ms-2 my-auto text-secondary">
                          {dataSales?.per_page} dari <span>{dataSales?.total}</span> <span>data</span>
                        </p>
                      </div>

                      <ul className="pagination m-0 ms-auto">
                        {/* PREV BUTTON */}
                        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                          <button className="page-link" onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}>
                            <svg width="24" height="24" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                              <path d="M15 6l-6 6l6 6" />
                            </svg>
                          </button>
                        </li>

                        {/* PAGE NUMBERS */}
                        {dataSales?.links?.slice(1, -1)?.map((item, index) => {
                          const pageNumber = item.url ? new URL(item.url).searchParams.get("page") : null;

                          return (
                            <li key={index} className={`page-item ${item?.active ? "active" : ""}`}>
                              {item.label !== "Previous" && item.label !== "Next" ? (
                                <button
                                  className="page-link"
                                  disabled={!pageNumber}
                                  onClick={() => pageNumber && setCurrentPage(Number(pageNumber))}>
                                  {item.label}
                                </button>
                              ) : null}
                            </li>
                          );
                        })}

                        {/* NEXT BUTTON */}
                        <li className={`page-item ${currentPage === dataSales?.last_page ? "disabled" : ""}`}>
                          <button
                            className="page-link"
                            onClick={() => setCurrentPage(parseInt(dataSales?.current_page) + 1)}>
                            <svg width="24" height="24" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                              <path d="M9 6l6 6l-6 6" />
                            </svg>
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <DetailSale sale={selectedSaleDetail} loading={isDetailLoading} onPrint={handlePrintInvoice} />
      <PaidRevenueModal
        userProfile={userProfile}
        summary={isSummaryCurrent ? dataSales?.summary : null}
        dateRange={dateRange}
        loading={isLoading}
        onRetry={refreshData}
      />
      <CashierSummaryModal
        summary={isSummaryCurrent ? dataSales?.summary : null}
        dateRange={dateRange}
        loading={isLoading}
        onRetry={refreshData}
      />
      <PaymentSettlementModal
        idModal="settle-sale"
        title="Pelunasan Penjualan"
        transaction={formState}
        nameLabel="Customer"
        nameValue={formState?.customer_name}
        loading={isLoading}
        storeSetting={storeSetting}
        onConfirm={handleSettle}
      />

      <DraftPaymentModal
        idModal="process-draft-sale"
        transaction={formState}
        loading={isLoading}
        storeSetting={storeSetting}
        onConfirm={handleProcess}
      />

      <AlertConfirmModal
        type="error"
        title="Batalkan transaksi?"
        message={`Transaksi ${formState?.details?.map((item) => item.product_name)?.join(", ")} akan dibatalkan. Jika transaksi sudah diproses, stok dan poin customer akan dikembalikan.`}
        confirmText="Batalkan"
        cancelText="Batal"
        requireReason
        reasonLabel="Alasan pembatalan"
        reasonPlaceholder="Contoh: pesanan salah, pelanggan membatalkan, atau transaksi ganda..."
        reasonHint="Tersimpan sebagai audit dan ikut dicatat pada reversal stok."
        waitForConfirm
        idModal="cancel-sale"
        idData={formState?.id}
        onConfirm={(id, reason) => {
          return handleCancel(id, reason);
        }}
        onCancel={() => {
          closeModal();
        }}
      />
      <BillManagementModal
        sale={formState}
        storeSetting={storeSetting}
        readOnly={!canEditSale(userProfile, formState)}
        canPay={canProcessSale(userProfile, formState)}
        onLoadBills={fetchSaleBills}
        onLoadEligible={fetchEligibleSaleBills}
        onSplit={(billId, groups) => splitSaleBill(billId, groups, { refreshSales: false })}
        onMerge={(billIds, label) => mergeSaleBills(billIds, label, { refreshSales: false })}
        onPay={(billId, payload) => paySaleBill(billId, payload, { refreshSales: false })}
        onUndo={(billId, reason) => undoSaleBill(billId, reason, { refreshSales: false })}
        onChanged={refreshData}
        onPrintBill={(billId) => {
          if (!formState?.id || !billId) return;
          navigate(`${PATH_URL.TESTING_PRINT_INVOICE.replace(":id", formState.id)}?bill_id=${billId}`);
        }}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  dataSales: state?.sales?.datas,
  sales: state?.sales?.datas?.data || [],
  isLoading: state?.sales?.loading,
  userProfile: state?.auth?.login?.profile,
  storeSetting: state?.stores?.setting,
});

export default connect(mapStateToProps, {
  fetchSales,
  getSaleById,
  processSale,
  cancelSale,
  settleSale,
  fetchSaleBills,
  fetchEligibleSaleBills,
  splitSaleBill,
  mergeSaleBills,
  paySaleBill,
  undoSaleBill,
})(SalePage);
